"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeLowestPricePromotion = void 0;
const typings_1 = require("../../typings");
const utils_1 = require("../../utils");
const base_1 = require("../base");
class FreeLowestPricePromotion extends base_1.BasePromotion {
    constructor(props) {
        super(props);
        this.props = props;
        this.DEFAULT_REPEATABLE_MULTIPLIER = 1;
        this.MINIUM_THRESHOLD_AMOUNT = 2;
    }
    isProductSKUsAmountLessThanMinimumThresholdAmount(cart) {
        if (!cart.productSKUs.length) {
            return true;
        }
        const totalProductSKUsAmount = (0, utils_1.getTotalAmount)(cart.productSKUs);
        return this.MINIUM_THRESHOLD_AMOUNT > totalProductSKUsAmount;
    }
    /**
     *  Sort min to max price of selected product SKUs in cart and select min price (first index of array)
     * @param cart
     * @returns {number}
     */
    getLowestPriceOfSelectedProductsInCart(cart) {
        const selectedProductsInCart = cart.productSKUs.filter((productSKU) => this.selectedProductIds.includes(productSKU.id));
        const sortedSelectedProductInCartByLowestPrice = [...selectedProductsInCart].sort((a, b) => {
            return a.price - b.price;
        });
        if (!sortedSelectedProductInCartByLowestPrice.length) {
            return undefined;
        }
        const lowestPriceProductInCart = sortedSelectedProductInCartByLowestPrice[0];
        return lowestPriceProductInCart;
    }
    /**
     * Apply free lowest price promotion for selected product in bundle
     * 3 piece of mix selected product to get the discount price as the lowest price of those
     * @param cart
     * @returns {Cart}
     */
    applyFreeLowestPriceForSelectedProductInBundlePromotion(cart) {
        const isBundled = this.bundleSetting;
        if (!isBundled) {
            throw new Error('Could not apply lowest price promotion for X piece of selected product in bundle that is not mark as bundled');
        }
        if (this.isProductSKUsAmountLessThanMinimumThresholdAmount(cart)) {
            return cart;
        }
        const matchedCriteria = this.getCriteriaByTarget((0, utils_1.getTotalAmountOfSelectedProducts)(cart.productSKUs, this.selectedProductIds));
        if (!matchedCriteria) {
            return cart;
        }
        const totalPriceOfMatchedProductSKUs = (0, utils_1.getTotalPriceOfSelectedProducts)(cart.productSKUs, this.selectedProductIds);
        const lowestPriceProductInCart = this.getLowestPriceOfSelectedProductsInCart(cart);
        if (!lowestPriceProductInCart) {
            return cart;
        }
        const totalDiscount = (0, utils_1.calculateDiscount)(this.DEFAULT_REPEATABLE_MULTIPLIER, lowestPriceProductInCart.price, totalPriceOfMatchedProductSKUs);
        const newCart = Object.assign({}, cart);
        const productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(newCart.productSKUs, {
            totalDiscount,
            appliedProductSKUIds: [lowestPriceProductInCart.id],
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, newCart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount });
    }
    /**
     * Apply free lowest price promotion for selected product in total of X price
     * Price of selected products and amount are more than threshold to get the discount price as the lowest price of those
     * @param cart
     * @returns {Cart}
     */
    applyFreeLowestPriceInTotalOfSelectedProductInBundlePromotion(cart) {
        const isBundled = this.bundleSetting;
        if (!isBundled) {
            throw new Error('Could not apply lowest price promotion for total X price of selected product in bundle that is not mark as bundled');
        }
        if (this.isProductSKUsAmountLessThanMinimumThresholdAmount(cart)) {
            return cart;
        }
        // total discount price for particular promotion
        const totalPriceOfMatchedProductSKUs = (0, utils_1.getTotalPriceOfSelectedProducts)(cart.productSKUs, this.selectedProductIds);
        const matchedCriteria = this.getCriteriaByTarget(totalPriceOfMatchedProductSKUs);
        if (!matchedCriteria) {
            return cart;
        }
        const lowestPriceProductInCart = this.getLowestPriceOfSelectedProductsInCart(cart);
        if (!lowestPriceProductInCart) {
            return cart;
        }
        const totalDiscount = (0, utils_1.calculateDiscount)(this.DEFAULT_REPEATABLE_MULTIPLIER, lowestPriceProductInCart.price, totalPriceOfMatchedProductSKUs);
        const newCart = Object.assign({}, cart);
        const productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(newCart.productSKUs, {
            totalDiscount,
            appliedProductSKUIds: [lowestPriceProductInCart.id],
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, newCart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount });
    }
    /**
     * Apply promotion
     * @param cart
     * @returns {Cart}
     */
    applyPromotion(cart) {
        switch (this.settingCondition) {
            case typings_1.PromotionCondition.BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE:
                return this.applyFreeLowestPriceForSelectedProductInBundlePromotion(cart);
            case typings_1.PromotionCondition.BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT_IN_BUNDLE:
                return this.applyFreeLowestPriceInTotalOfSelectedProductInBundlePromotion(cart);
            default:
                return cart;
        }
    }
}
exports.FreeLowestPricePromotion = FreeLowestPricePromotion;
//# sourceMappingURL=free-lowest-price.js.map